import { createContext, useEffect, useRef, useState } from "react";

export const ScrollContext = createContext(false);

export const ScrollProvider = ({ children }) => {
  const [scrolled, setScrolled] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const target = scrollRef.current || window;

    const handleScroll = () => {
      const scrollTop = scrollRef.current
        ? scrollRef.current.scrollTop
        : window.scrollY;

      const halfway = window.innerHeight * 0.9;

      setScrolled(scrollTop > halfway);
    };

    target.addEventListener("scroll", handleScroll);
    return () => target.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={scrolled}>
      <div ref={scrollRef} className="h-screen w-full overflow-y-scroll">
        {children}
      </div>
    </ScrollContext.Provider>
  );
};
